module.exports = __webpack_public_path__ + "img/channel.b2734.png";